import { z } from 'zod';
/**
 * `GET|PATCH /api/web/tenant/privacy-settings` — the caller's OWN tenant's privacy switches
 * (docs/adr/0032 Slice 3). Platform-admin Settings → Privacy.
 *
 * TENANT-SCOPED by the verified token: neither the DTO nor the update carries a `tenantId`
 * (docs/008 S1) — the server reads it from the session, never from the body.
 *
 * `kioskAnalyticsEnabled` — whether this tenant's paired kiosks send product-usage analytics
 * (Firebase / GA4). OFF by default, an explicit opt-in by a tenant admin. Crash reporting is
 * NOT governed by it (ADR 0032 owner decision 2: always on). A change reaches every kiosk on
 * its next session read or heartbeat, through `deviceSessionDTOSchema.kioskAnalyticsEnabled`.
 */
export const tenantPrivacySettingsDTOSchema = z.object({
    kioskAnalyticsEnabled: z.boolean(),
});
/**
 * The PATCH body. One switch today, so it is required rather than a partial — a body that
 * names nothing would be a no-op request that still writes nothing, and `.strict()` refuses
 * any key this contract does not declare (a smuggled `tenantId` included).
 */
export const updateTenantPrivacySettingsSchema = z
    .object({
    kioskAnalyticsEnabled: z.boolean(),
})
    .strict();
//# sourceMappingURL=tenant-privacy-settings.js.map